// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"f4139772","72":"aadb8dc3","84":"ae4d895f","116":"24f3c520","176":"2664c24d","204":"ce1e0a88","232":"6cadf69c","344":"7e619341","488":"704de989","496":"732bab41","540":"b8e68281","632":"499e5d4f","816":"d52f722a","852":"f967ae79","988":"445c96bb"}[chunkId] + ".chunk.js";
};